//import { LandingPageComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { AdvantagesOfMutualFundsComponent } from './advantages-of-mutual-funds/advantages-of-mutual-funds.component';
import { CategorizationOfMutualFundsComponent } from './categorization-of-mutual-funds/categorization-of-mutual-funds.component';
import { ContactComponent } from './contact/contact.component';
import { FAQComponent } from './faq/faq.component';
import { IframeCalculatorComponent } from './iframe-calculator/iframe-calculator.component';
import { MarketViewsComponent } from './market-views/market-views.component';
import { MobileMutualFundComponent } from './mobile-mutual-fund/mobile-mutual-fund.component';
import { MutualFundComponent } from './mutual-fund/mutual-fund.component';
import { ReviewComponent } from './review/review.component';
import { RisksInMutualFundsComponent } from './risks-in-mutual-funds/risks-in-mutual-funds.component';
import { SIPComponent } from './sip/sip.component';
import { TypesOfMFComponent } from './types-of-mf/types-of-mf.component';
import { WealthCalculatorsComponent } from './wealth-calculators/wealth-calculators.component';
// import { LoginEmployeeAlankitComponent } from '../login-employee-alankit/login-employee-alankit.component';

const routes: Routes = [
  // { path: '', redirectTo:  'home', pathMatch: 'full' },
  // {path:'home',component:LandingPageComponent},
  {
    path: 'Advantages_Of_MutualFundsComponent',
    component: AdvantagesOfMutualFundsComponent
  },
  {
    path: 'categorization-of-mutual-funds',
    component: CategorizationOfMutualFundsComponent
  },
  { path: 'FAQ', component: FAQComponent },
  { path: 'iframe-calculator', component: IframeCalculatorComponent },
  { path: 'Mutual-Fund', component: MutualFundComponent },
  { path: 'SIP', component: SIPComponent },
  { path: 'Types_Of_MF', component: TypesOfMFComponent },
  { path: 'Wealth_Calculators', component: WealthCalculatorsComponent },
  { path: 'risks-in-mutual-funds', component: RisksInMutualFundsComponent },
  { path: 'About', component: AboutComponent },
  { path: 'Contact', component: ContactComponent },
  { path: 'MarketViews', component: MarketViewsComponent },
  { path: 'MobileMutualFund', component: MobileMutualFundComponent },
  { path: 'Reviews', component: ReviewComponent }
  // { path: '/login/investor' ,component : LoginEmployeeAlankitComponent} //added by adarsh
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IfaRoutingModule {}
